import { render, staticRenderFns } from "./TitleCredits.vue?vue&type=template&id=7c5d5e6b"
import script from "./TitleCredits.vue?vue&type=script&lang=ts&setup=true"
export * from "./TitleCredits.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./TitleCredits.vue?vue&type=style&index=0&id=7c5d5e6b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports